const config = {
  404: {
    img: require('./assets/404.png'),
    title: '宝宝树孕育',
    desc: '全国妈妈首选的育儿神器'
  }
};

export default config;
